import AttendAchievementListPage  from "./AttendAchievementListPage";

export default AttendAchievementListPage